import { useContext, useEffect, useRef, useState } from "react";
import { useHistory, Redirect, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import styles from "./singleTour.module.css";
import "./payment-section.scss";

import TourPassangers from "./TourPassangers";

import AuthenticationContext from "Authentication/AuthenticationContext";

import { reserveTour } from "services/reserveTour";
import { priceConverter } from "utilities/kHelperHunction";
import toast from "react-hot-toast";

export default function FinalSection({ finalSectionData }) {
  const history = useHistory();

  const params = useParams();

  const { userInfo, isLogged } = useContext(AuthenticationContext);

  const [mainStatus, setMainStatus] = useState(0);
  const [payType, setPayType] = useState("online");
  const [payPrice, setPayPrice] = useState(0);
  const [wallet, setWallet] = useState(false);
  const [totalPricePerPerson, setTotalPricePerPerson] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [pastPassangers, setPastPassangers] = useState([]);
  const [price, setPrice] = useState({
    basePrice: 0,
    otherPrices: [],
    absolutePrice: { price: 0, state: true },
    reservation: false,
    reserveWithoutPrepayment: { state: false },
    reserveWithPrepayment: { state: false, price: 0 },
  });
  const [busType, setBusType] = useState();
  const [seats, setSeats] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState(0);
  const [rules, setRules] = useState(false);
  const [passangers, setPassangers] = useState([]);
  const [tourId, setTourId] = useState(-1);
  const [capacity, setCapacity] = useState(0);

  const linkRef = useRef();

  const changeSeats = (theSeats) => {
    setSeats(theSeats);
  };
  const changeBusType = (type) => setBusType(type);
  const changeSelectedGateway = (gateway) => setSelectedGateway(gateway);

  const addPassanger = (passanger) => {
    if (capacity - (passangers.length + 2) < 0) {
      toast.error(" شما نمیتوانید برای این تعداد، تور رزرو کنید.");
      return;
    }
    setPassangers([...passangers, passanger]);
  };

  const changePrice = (x) => {
    setPrice(x);
  };

  const changeRules = (x) => {
    setRules(x);
  };

  const pay = async () => {
    let res = await reserveTour(
      userInfo.id,
      tourId,
      seats,
      busType,
      totalPrice,
      payPrice,
      payType,
      passangers
      // ac
    );
    if (res.state != 0) {
      if (res.state == 1) {
        linkRef.current.href = res.url;
        linkRef.current.click();
      } else {
        Swal.fire({
          title: "رزرو تور با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        }).then((result) => {
          if (result.isConfirmed) {
            history.push(res.url);
          }
        });
      }
    } else {
      Swal.fire({
        title: "خطا!",
        text: "مشکلی در ثبت اطلاعات بوجود آمده است، لطفا بعدا تلاش کنید.",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
  };

  useEffect(() => {
    // async function loadPage(id) {
    //   setTourId(id);
    //   if (isLogged) {
    //     changeLoader(true);
    //     let res = await getTourInfoForReserve(id, userInfo.id);
    //     console.log("res", res);
    //     // todo
    //     // setMainStatus(res.info.main_status);
    //     setMainStatus(4);
    //     setCapacity(res.info.capacity);
    //     setSeats(res.seats);
    //     setBusType(res.busType);
    //     setPrice(res.prices);
    //     setPastPassangers(res.pastPassangers);
    //     setWallet(res.wallet);
    //     if (res.wallet !== false && res.wallet != 0) {
    //       setPayType("wallet");
    //     }
    //     changeLoader(false);
    //   }
    // }

    // let id = params.tourId;
    // loadPage(id).catch((error) => {
    //   console.log(error);
    // });
console.log({finalSectionData})
    setTourId(finalSectionData.tourId);
    setMainStatus(finalSectionData.mainStatus);
    setCapacity(finalSectionData.capacity);
    setSeats(finalSectionData.seats);
    setBusType(finalSectionData.busType);
    setPrice(finalSectionData.prices);
    setPastPassangers(finalSectionData.pastPassangers);
    setWallet(finalSectionData.wallet);
    if (finalSectionData.wallet !== false && finalSectionData.wallet != 0) {
      setPayType("wallet");
    }
  }, [finalSectionData]);

  useEffect(() => {
    setPastPassangers(
      pastPassangers.filter(
        (value) => !passangers.some((val) => val.id == value.id)
      )
    );
  }, [passangers]);

  useEffect(() => {
    let sum = 0;
    for (const x in price) {
      if (x == "otherPrices") {
        sum += price.otherPrices.reduce((total, value) => {
          if (value.state) {
            return total + value.price;
          }
          return total;
        }, 0);
      }
      if (price[x].state && typeof price[x].price !== "undefined") {
        sum += price[x].price;
      }
    }
    setTotalPricePerPerson(sum);
  }, [price]);

  useEffect(() => {
    let finalPrice = totalPricePerPerson * (passangers.length + 1);
    setTotalPrice(finalPrice);
    if (payType == "wallet") finalPrice -= wallet;
    setPayPrice(finalPrice > 0 ? finalPrice : 0);
  }, [totalPricePerPerson, wallet, passangers, payType]);


  console.log(mainStatus)
  return (
    <>
      <a ref={linkRef} className="d-none" href="#"></a>
      {isLogged === false ? (
        <div className="d-flex justify-content-center">
          <div className="the-reserve-alert">
            برای خرید تور ابتدا وارد حساب کاربری خود شوید.{" "}
          </div>
        </div>
      ) : capacity == 0 || capacity - (passangers.length + 1) < 0 ? (
        <div className="d-flex justify-content-center">
          <div className="the-reserve-alert">
            {" "}
            ظرفیت این تور تکمیل شده است.{" "}
          </div>
        </div>
      ) : mainStatus != 4 ? (
        <div className="d-flex justify-content-center">
          <div className="the-reserve-alert"> این تور خارج از رزرو است. </div>
        </div>
      ) : (
        <>
          {/* همراهان  */}
          <p className={styles.jazebeHead2}> همراهان</p>
          <TourPassangers
            passangers={passangers}
            addPassanger={addPassanger}
            pastPassangers={pastPassangers}
            busType={busType}
            seats={seats}
            changeBusType={changeBusType}
            changeSeats={changeSeats}
            selectedSeats={selectedSeats}
            setSelectedSeats={setSelectedSeats}
            capacity={capacity}
            main_status={mainStatus}
          />

          {/* پرداخت هزینه */}
          <p className={styles.jazebeHead3}> فاکتور تور</p>
          <div className={styles.factorBoox}>
            {/* 
            <div className={styles.factorBooxText}>
              <span className={styles.factorBooxHead}>نوع خرید : </span>
              <span className={styles.factorBooxspan}>
                <div class="form-check ">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault4"
                  />
                  <label
                    class={`form-check-label ${styles.kif}`}
                    for="flexRadioDefault4"
                  >
                    قطعی
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault3"
                  />
                  <label
                    class={`form-check-label ${styles.kif2}`}
                    for="flexRadioDefault3"
                  >
                    رزرو یا پیش پرداخت
                  </label>
                </div>
              </span>
            </div> */}
            <div className={styles.factorBooxText}>
              <span className={styles.factorBooxHead}>مبلغ نهایی : </span>
              <span className={styles.factorBooxspan}>
                {priceConverter(totalPrice)}
              </span>
            </div>
            {wallet !== false && payType === "wallet" ? (
              <div className={styles.factorBooxText}>
                <span className={styles.factorBooxHead}>موجودی کیف پول : </span>
                <span className={styles.factorBooxspan}>
                  {priceConverter(wallet)}
                </span>
              </div>
            ) : (
              ""
            )}
            <div className={styles.factorBooxText}>
              <span className={styles.factorBooxHead}>مبلغ قابل پرداخت : </span>
              <span className={styles.factorBooxspan}>
                {priceConverter(payPrice)}
              </span>
            </div>
            <div className={styles.factorBooxText}>
              <span className={styles.factorBooxHead}> شیوه پرداخت : </span>
              <span className={styles.factorBooxspan}>
                <div class="form-check ">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    checked={payType === "online"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPayType("online");
                      }
                    }}
                  />
                  <label
                    class={`form-check-label ${styles.kif}`}
                    for="flexRadioDefault1"
                  >
                    آنلاین
                  </label>
                </div>
                <div class="form-check ">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    checked={payType === "wallet"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPayType("wallet");
                      }
                    }}
                  />
                  <label
                    class={`form-check-label ${styles.kif3}`}
                    for="flexRadioDefault2"
                  >
                    کیف پول
                  </label>
                </div>
              </span>
            </div>
            <div className="d-flex">
              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexRadioDefault5"
                  onChange={(e) => setRules(e.target.checked)}
                />
                <label
                  class={`form-check-label ${styles.factorBooxHead}`}
                  for="flexRadioDefault5"
                  style={{ width: "200px" }}
                >
                  مطالعه قوانین و مقررات
                </label>
              </div>
              <button
                className="btn btn-success rounded text-light "
                style={{ fontWeight: "bold" }}
                disabled={
                  !rules ||
                  // (payType == "online" && selectedGateway == null) ||
                  ("1,2".includes(busType) &&
                    selectedSeats != passangers.length + 1)
                }
                onClick={pay}
              >
                {" "}
                پرداخت
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
